import { render, staticRenderFns } from "./OrderPaymentsHistory.vue?vue&type=template&id=5ee56732&"
import script from "./OrderPaymentsHistory.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports